






















import { Vue, Component, Prop } from 'vue-property-decorator'
import ExpandablePreview from 'components/ExpandablePreview.vue'
import MarkdownViewer from 'components/MarkdownViewer.vue'

@Component({
  components: {
    ExpandablePreview,
    MarkdownViewer
  }
})
export default class AttendeeItemTopic extends Vue {

  @Prop()
  readonly slide!: Json

  get info () {
    return this.slide.info?.trim()
  }

  get files () {
    return this.slide.files || []
  }

  urlFileName (url: string) {
    return url.split('/').pop() || 'file'
  }

  download (url: string, name: string) {
    const a = document.createElement('a')
    a.style.display = 'none';
    document.body.appendChild(a)
    a.href = url
    a.setAttribute('download', name || this.urlFileName(url))
    a.setAttribute('target', '_blank')
    a.click()
    document.body.removeChild(a)
  }
}
